<div class="registration">
  <div class="registration--container">
    <div class="registration--header">
      <img
        class="registration--logo"
        [src]="isRaymond ? 'assets/images/raymond_logo.svg' : 'assets/MyToyota_Black.svg'"
        [alt]="state.registrationPage.logo.altText"
        tabindex="0"
      />
      <a class="registration--log-out" tabindex="0" (click)="logout()">{{
        state.registrationPage.logoutLabel
      }}</a>
    </div>
    <div tabindex="-1" class="registration--title">
      <p tabindex="0" class="registration--step">
        {{ state.registrationPage.stepLabel }}
      </p>
      <h1 tabindex="0" class="registration--complete-title">
        {{ state.registrationPage.pageHeading }}
      </h1>
      <p tabindex="0" class="registration--description" *ngIf="!service.isContinueSuccess">
        {{ state.registrationPage.pageDescription }}
      </p>
      <p tabindex="0" class="registration--description-step5" *ngIf="service.isContinueSuccess && !isRaymond">
        {{state.registrationPage.additionalLocation.locationPageDescription.description1}}<span class="highlight">{{state.registrationPage.additionalLocation.locationPageDescription.tokenData[0].text}}</span>{{state.registrationPage.additionalLocation.locationPageDescription.description2}}
      </p>
      <p tabindex="0" class="registration--description-step5 raymond-admin-description-step4" *ngIf="service.isContinueSuccess && isRaymond">
        {{state.registrationPage.pageDescription}}
      </p>
    </div>

     <div class="registration--section-1-and-2"  *ngIf="!service.isContinueSuccess">
      <tmhna-portal-registration-profile-company-information [state]="state"></tmhna-portal-registration-profile-company-information>
    </div>
    <div class="registration--section-3" *ngIf="service.isTCSection && !service.isModifyButtonClicked && !service.isContinueSuccess">
        <tmhna-portal-registration-terms-and-conditions (termsAndPolicyConditionAgreed)="isTermsandPrivacyAgreed($event)"></tmhna-portal-registration-terms-and-conditions>
    </div>
    
    <div class="registration--button-container" *ngIf="service.isTCSection && !service.isModifyButtonClicked && !service.isContinueSuccess">
      <kng-button *ngIf="service.isSubmitRegistrationButton"
        id="saveRegistration"
        class="registrationButton"
        [state]="state.submitButton"
        (clicked)="onSubmitRegistration()"
      ></kng-button>
      <kng-button *ngIf="service.isContinueButton"
        id="continueBtn"
        class="continueButton"
        [state]="state.continueButton"
        (clicked)="onContinue()"
      ></kng-button>
    </div>
    <div class="registration--section-5" *ngIf="service.isContinueSuccess">
      <tmhna-portal-registration-additional-locations></tmhna-portal-registration-additional-locations>
    </div>
  </div>
  <kng-footer [state]="state.footer" (languageSelectionChanged)="notifyLanguageChange($event)"> </kng-footer>
</div>
<div class="overlay" *ngIf="state.loading">
  <kng-loader [state]="loaderState"></kng-loader>
</div>
